import { range } from 'lodash';
import { DeepPartial } from 'redux';
import { AdminState } from 'reduxStore/appStore';

export const DEFAULT_DATE_FORMAT = 'DD/MM/YYYY';
export const API_DATE_FORMAT = 'YYYY-MM-DD';

export const VARIABLE_CONFIDENTIALITY_THRESHOLD_DISABLED_OPTION = -1;
export const VARIABLE_CONFIDENTIALITY_THRESHOLD_OPTIONS = range(3, 21);
export const VARIABLE_CONFIDENTIALITY_THRESHOLD_TOOLTIP = `We will take this value and 
  calculate the total sum of  groups within a demographic filter that do not meet the confidentiality threshold, above. 
  If the sum in those groups is under this variable threshold then we may apply a confidentiality protection message to 
  all filters within that group to protect the confidentiality of those smaller groups.`;

export const WB_CIRCLE_NAME = 'WorkBuzz';

export enum SortDirection {
  ASC = 'asc',
  DESC = 'desc',
}

export const wrappedReduxStateSnapshot: DeepPartial<{ state: AdminState }> = {};
export const latestReduxActions: { type: string; payload: any }[] = []; // Max 30 actions

/**
 * Label by value aggregation months map
 */
export const aggregationMonthsMap = {
  '1 year': '12',
  '2 years': '24',
  '3 years': '36',
  '4 years': '48',
  '5 years': '60',
};

export const MAX_FOCUS_AREAS_OPTIONS = [2, 4, 6];
export const MAX_ACTIONS_PER_FOCUS_AREA_OPTIONS = [1, 2, 3];
export const DEFAULT_MAX_FOCUS_AREAS = 2;
export const DEFAULT_MAX_ACTIONS_PER_FOCUS_AREA = 1;
